import * as Sentry from '@sentry/sveltekit';

import * as wand from '$lib/api/wand';

let username = $state<string>('');
let roles = $state<string[]>([]);
let adminFlag = $state<boolean>(false);
let loaded = $state<boolean>(false);

export function getUsername(): string {
  return username;
}

export function getRoles(): string[] {
  return roles;
}

export function isAdmin(): boolean {
  return adminFlag;
}

export function isLoaded(): boolean {
  return loaded;
}

export async function fetchIdentity(): Promise<void> {
  const info = await wand.whoami();
  username = info.username;
  roles = info.roles;
  adminFlag = info.isAdmin;
  loaded = true;
  Sentry.setUser({ username });
}
